import {useMarkdownConverter} from '#imports';

export function useWordCount() {
    const mdConvert = useMarkdownConverter();

    function countWords(text: string) {
        return text.match(/\p{L}[\p{L}'-]*/gu)?.length || 0;
    }

    function countWordsInHtml(html: string): number {
        return countWords(mdConvert.htmlToMd(html));
    }

    return {countWords, countWordsInHtml};
}
